(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('slideshow:select', (event) => {
    const statusEl = event.target?.refs?.slideStatus;
    if (!statusEl) return;

    const template = statusEl.dataset.statusTemplate;
    if (!template) return;

    statusEl.textContent = template.replace('__INDEX__', event.detail.index + 1);
  });
  } catch(e) { console.error(e); }
})();

})();
